<template>
  <div class="list">
    <div class="item">
      <div class="view">
        <div class="canvasOuter">
          <canvas ref="canvas1" width="140" height="140" />
        </div>
      </div>
    </div>
    <div class="item">
      <div class="view">
        <div class="canvasOuter">
          <canvas ref="canvas2" width="140" height="140" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// https://codepen.io/493msi/pen/PZWLLv
import MaterialSpinner from '@/modules/day3-material-spinner.js'

export default {
  name: 'Day3',
  data: () => ({
    spinner1: false,
    spinner2: false
  }),
  beforeDestroy() {
    if (this.spinner1) {
      this.spinner1.destroy()
    }
    if (this.spinner2) {
      this.spinner2.destroy()
    }
  },
  mounted() {
    this.spinner1 = new MaterialSpinner(this.$refs.canvas1, {
      color: '#111111'
    })
    this.spinner2 = new MaterialSpinner(this.$refs.canvas2, {
      color: '#dddddd'
    })
  }
}
</script>

<style scoped lang="scss">
.view {
  @include FR_FULLSIZE;
}

.canvasOuter {
  @include FR_CENTER(xy);
  position: absolute;
  width: 70px;
  height: 70px;

  canvas {
    @include FR_FULLSIZE;
  }
}
</style>
